import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var S7ProfiCircle = function S7ProfiCircle(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.007 48C37.262 48 48 37.264 48 24.005S37.263 0 24.007 0C10.75 0 0 10.746 0 24.005 0 37.265 10.75 48 24.007 48zm-1.869-36.427c-3.76 0-6.199.208-7.965.863-2.967 1.156-5.016 3.579-5.016 6.762 0 2.652 1.235 4.572 4.808 6.78 3.813 2.312 4.573 3.076 4.573 4.468 0 1.525-1.493 3.26-5.336 3.26-1.34 0-3.361-.186-4.652-.502l-.616-.155c-.343.921-1.123 3.1-1.361 3.89l.61.18c1.16.37 3.917.66 5.89.66 6.568 0 10.487-3.968 10.487-8.123 0-2.553-1.16-4.494-5.077-6.938-1.965-1.21-2.966-1.993-3.575-2.6-.492-.633-.547-1.105-.547-1.603 0-.475.106-1.023.42-1.424.338-.496.96-.813 1.802-1.073.865-.287 2.467-.295 4.964-.295h2.324l1.66-4.15h-3.392zm17.565 0h-11.68l-1.659 4.15h3.871a87.43 87.43 0 003.073-.042c.268-.008.47-.014.688-.014-.945 2.16-6.636 16.663-6.636 16.663h4.817s7.205-18.054 7.969-19.947c.211-.422.106-.81-.443-.81z",
    fill: "#00A4BA"
  }));
};
export default S7ProfiCircle;